import { Component, Input, ChangeDetectorRef, OnChanges, SimpleChanges, ViewChild, ViewContainerRef, ComponentFactoryResolver, ComponentRef, OnDestroy } from '@angular/core';
import { ErrorLoggerService, NotificationService } from 'app/services';
import { TranslateService } from '@ngx-translate/core';
import { CustomSectionHandler } from '../../entities/shared/custom.section';

@Component({
    selector: 'key-admin-custom',
    templateUrl: './custom.component.html',
    standalone: false
})
export class AdminCustomEditorComponent implements OnChanges, OnDestroy {

    @Input() entity: any;
    @Input() handler: CustomSectionHandler<any, any>;
    @Input() editable: boolean;
    @Input() visible = false;

    @ViewChild('templateContainer', { read: ViewContainerRef, static: true }) container: ViewContainerRef;

    errorMessage: string;

    componentRef: ComponentRef<any>;

    constructor(
        private error: ErrorLoggerService,
        private notify: NotificationService,
        public i18n: TranslateService,
        private ref: ChangeDetectorRef,
        private resolver: ComponentFactoryResolver
    ) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.handler && this.handler) {
            this.load().catch(err => this.showError(err));
        }
    }

    ngOnDestroy() {
        this.clear();
    }

    async load(): Promise<void> {
        try {
            this.errorMessage = null;
            this.clear();
            this.refresh();
        } catch (err) {
            this.showError(err);
        }
    }

    async refresh() {
        try {
            if (this.entity) {
                this.errorMessage = null;
                if (this.handler.getComponentFactory) {
                    if (!this.componentRef) {
                        const factory = this.handler.getComponentFactory(this.resolver);
                        this.componentRef = this.container.createComponent(factory);
                    }
                    this.componentRef.instance.entity = this.entity;
                    this.componentRef.instance.handler = this.handler;
                    this.componentRef.instance.visible = this.visible;
                    if (this.componentRef.instance.ngOnChanges) {
                        this.componentRef.instance.ngOnChanges();
                    }
                }
            }
            this.ref.markForCheck();
        } catch (err) {
            this.showError(err);
        }
    }

    clear() {
        this.container.clear();
        if (this.componentRef) {
            this.componentRef.destroy();
            this.componentRef = null;
        }

    }

    showError(error: any) {
        this.error.trackException(error);
        this.errorMessage = error && this.notify.translateError(error);
        this.ref.markForCheck();
    }

}
